import { CheckCircle, AlertTriangle, XCircle, Loader2, HelpCircle, Server, Users, AlertOctagon } from "lucide-react";

const iconMap = {
  success: CheckCircle,
  warning: AlertTriangle,
  error: XCircle,
  running: Loader2,
  unknown: HelpCircle,
  servers: Server,
  clients: Users,
  stale: AlertOctagon
};

const colorMap = {
  success: "text-emerald-500 bg-emerald-500/10",
  warning: "text-amber-500 bg-amber-500/10",
  error: "text-red-500 bg-red-500/10",
  running: "text-blue-500 bg-blue-500/10",
  unknown: "text-slate-500 bg-slate-500/10",
  servers: "text-indigo-500 bg-indigo-500/10",
  clients: "text-purple-500 bg-purple-500/10",
  stale: "text-orange-500 bg-orange-500/10"
};

const StatsCard = ({ type, value, label }) => {
  const Icon = iconMap[type] || Server;
  const colorClass = colorMap[type] || colorMap.servers;
  const [textColor, bgColor] = colorClass.split(" ");

  return (
    <div className="glass-card rounded-lg p-4" data-testid={`stats-${type}`}>
      <div className="flex items-center gap-3">
        <div className={`p-3 rounded-lg ${bgColor}`}>
          <Icon className={`${textColor} ${type === "running" ? "animate-spin" : ""}`} size={24} />
        </div>
        <div>
          <p className="font-heading text-3xl font-bold text-white">{value}</p>
          <p className="text-sm text-slate-400">{label}</p>
        </div>
      </div>
    </div>
  );
};

export default StatsCard;
